import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import IOSLayoutSettings from './IOSLayoutSettings';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {
  const title = intl?.formatMessage(messages.appLayoutSettings)
  // From Redux Store
  let isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
  const adminPrivileges = store?.getState()?.account?.privileges?.privileges;
  const privileges = store?.getState()?.listSettings?.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/settings/ios-layout', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><IOSLayoutSettings title={title} /></AdminLayout>,
  };
};
